export class WindowResize {
    offsetWidth: number;
    offsetHeight: number;
    sizeBootStrap?: string;
}